'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import React from 'react';
import { getRegionalUrl } from '@/lib/utils';

interface Item {
  id: string;
  title: string;
  body_color: string;
  background_color: string;
  background_image: string;
  title_text_color: string;
  cta_buttons: {
    text: string;
    text_color: string;
    btn_color: string;
    cta_url: string;
    hover_btn_color: string;
    hover_text_color: string;
  }[];
}

const TextCTABanner = ({ item }: { item: Item }) => {
  const params = useParams<{ countryCode?: string }>();
  return (
    <div
      style={{ backgroundColor: item?.body_color }}
      className="w-full lg:px-0 md:px-4 px-0 "
    >
      <div
        style={{ backgroundColor: item?.background_color }}
        className="max-w-[1408px] w-full mx-auto md:h-[120px] relative overflow-hidden px-4 py-6 md:py-0 md:rounded-[12px] md:px-8 flex md:flex-row flex-col text-center gap-4 items-center justify-between"
      >
        <h2
          style={{ color: item?.title_text_color }}
          className="text-2xl leading-[32px] md:text-[32px] md:leading-[48px] font-bold z-10"
        >
          {item?.title}
        </h2>

        <div className="w-full md:w-auto flex md:flex-row flex-col items-center justify-center gap-4 z-10">
          {item?.cta_buttons?.map((cta, idx) => {
            return (
              <Link
                key={idx}
                href={getRegionalUrl(cta?.cta_url ?? '/', params?.countryCode)}
                style={
                  {
                    ['--btn-bg' as any]: cta?.btn_color,
                    ['--btn-text' as any]: cta?.text_color,
                    backgroundColor: 'var(--btn-bg)',
                    color: 'var(--btn-text)',
                  } as React.CSSProperties
                }
                className={`px-8 h-[56px] md:w-auto w-full md:max-lg:min-w-[160px] md:max-lg:shrink-0 md:max-lg:whitespace-nowrap flex items-center justify-center rounded-[12px] hover:opacity-80 text-[18px] font-proxima_font font-semibold leading-none transition-all duration-200`}
                // onMouseEnter={(e) => {
                //   e.currentTarget.style.backgroundColor =
                //     cta?.hover_btn_color ?? 'inherit';
                //   e.currentTarget.style.color = cta?.hover_text_color || '';
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.style.backgroundColor = cta?.btn_color;
                //   e.currentTarget.style.color = cta?.text_color || '';
                // }}
              >
                {cta?.text}
              </Link>
            );
          })}
        </div>

        {item?.background_image && (
          <div className="w-full h-full absolute left-0 top-0">
            <Image
              src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/${item?.background_image}`}
              alt={item?.title}
              title={item?.title}
              fill
              sizes="(max-width: 1408px) 100vw, 1408px"
              className="object-cover select-none"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TextCTABanner;
